/* eslint-disable @typescript-eslint/no-explicit-any */
import dynamic from 'next/dynamic'
import LessonEntry from '../LessonEntry'
import VideoLoading from '../VideoLoading'
import BlockContent from '@sanity/block-content-to-react'
import blockContentSerializers from '../../helpers/block-content-serializers'

import styles from './Styles.module.scss'
const VideoPlayer = dynamic(() => import('../VideoPlayer'), {
  ssr: false,
  loading: () => <VideoLoading />,
})
const YouTube = dynamic(() => import('../YouTube'), { ssr: false, loading: () => <VideoLoading /> })

import BEMHelper from '@/helpers/bem'
import { dataset, projectId } from '@/api/sanity'
const bem = BEMHelper(styles)

interface Props {
  video: any
  videoType: string
  title: string
  description: string | any[]
  caption: string
  lessonRef: any[]
}

export default function Video({ video, videoType, title, description, caption, lessonRef }: Props) {
  const hasLessons = lessonRef && lessonRef.length > 0

  return (
    <div {...bem('')}>
      <div {...bem('content')}>
        {video && videoType === 'internal' && video?.videoFile && (
          <VideoPlayer
            playbackId={video?.videoFile?.asset?.playbackId}
            aspectRatio={video?.videoFile?.asset?.data?.aspectRatio ?? ''}
            caption={caption || ''}
            title={title || ''}
          />
        )}
        {video && videoType === 'youtube' && <YouTube id={video} caption={caption || ''} />}

        <div {...bem('separator')} />

        {title && <h1 {...bem('title')}>{title}</h1>}

        {description && <div {...bem('description')}>
          {Array.isArray(description) ? <BlockContent
            renderContainerOnSingleChild
            {...bem('text')}
            blocks={description}
            serializers={blockContentSerializers}
            dataset={dataset}
            projectId={projectId}
          /> : <p {...bem('description')}>{description}</p>}
        </div>
        }

        {hasLessons && (
          <>
            <div {...bem('separator')}></div>
            <div {...bem('')}>
              <h2 {...bem('sub-title')}>Undervisningsopplegg</h2>
              <LessonEntry items={lessonRef} />
            </div>
          </>
        )}
      </div>
    </div>
  )
}
